module.exports = __webpack_public_path__ + "elephant_ui_working-2e653cc278c2ac871c23aeb10de1c0e2.svg";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/images/elephant_ui_working.svg
// module id = 257
// module chunks = 76